import { FC } from 'react';

import CopyToClipboardButton from '@features/copy-to-clipboard-button';
import { reduceString } from '@shared/utils/reduceString';

interface IProps {
  address: string | null;
  size?: number;
}

export const WalletAddressLink: FC<IProps> = ({ address, size = 4 }) => {
  if (!address) return null;

  return (
    <div className='table-cell-items' style={{ overflow: 'hidden' }}>
      <div>
        <a
          href={`https://tronscan.org/#/address/${address}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          {reduceString({ text: address, size })}
        </a>
      </div>
      <CopyToClipboardButton text={address} />
    </div>
  );
};
